import React from 'react';
import { Box, CircularProgress } from '@mui/material';
import { StylovyzeComposableDialog, Button, Text } from '@innovyze/stylovyze';
import { useGlobalization } from '@Translations/useGlobalization';

interface SaveConfirmationDialogProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  isLoading?: boolean;
}

const SaveConfirmationDialog: React.FC<SaveConfirmationDialogProps> = ({
  isOpen,
  onClose,
  onConfirm,
  isLoading = false,
}) => {
  const { t } = useGlobalization();

  return (
    <StylovyzeComposableDialog
      open={isOpen}
      onCancel={onClose}
      title={t('Save Changes')}
      width="500px"
      dialogProps={{
        sx: {
          '& .MuiDialog-paper': {
            maxWidth: { xs: '90vw', sm: '500px' },
            width: '100%',
            margin: { xs: 1, sm: 3 },
          },
        },
      }}
      footer={
        <Box sx={{ display: 'flex', justifyContent: 'flex-end', gap: 1, p: 2 }}>
          <Button
            onClick={onClose}
            color="secondary"
            variant="outlined"
            disabled={isLoading}>
            {t('Cancel')}{' '}
          </Button>
          <Button
            onClick={onConfirm}
            color="primary"
            variant="contained"
            disabled={isLoading}
            startIcon={isLoading ? <CircularProgress size={16} /> : undefined}>
            {t('Save')}
          </Button>
        </Box>
      }>
      <Text variant="text-large">
        {t('Are you sure you want to save the changes?')}
      </Text>
    </StylovyzeComposableDialog>
  );
};

export default SaveConfirmationDialog;
